import { Color } from "store/features/colorPicker/types";
import { rgbToCMYK } from "./rgbToCMYK";
import tinycolor from "tinycolor2";

export const getColorInfo = (r: number, g: number, b: number, a: number): Color => {
    const tiny = tinycolor({ r, g, b, a });
    const rgb = tiny.toRgbString();
    const hex =
        a && (a < 1 || (a > 1 && a < 100)) ? tiny.toHex8String().toUpperCase() : tiny.toHexString().toUpperCase();
    const hsl = tiny.toHslString();
    const hsv = tiny.toHsvString();
    const cmyk = rgbToCMYK(r, g, b, a);

    return {
        rgb,
        cmyk: `cmyk(${cmyk.c}%, ${cmyk.m}%, ${cmyk.y}%, ${cmyk.k}%, ${cmyk.a}%)`,
        hex,
        hsl,
        hsv,
    };
};
